import { colorAgentBorder, colorPrimaryDeepBlue } from '@libs/agent-chat';
import { useUser } from '@libs/contexts';
import { CompanyButton, CompanyMenu, UserButton, UserMenu } from '@libs/templates/global-area/components';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router';

export function AiHeadMenu() {
  const { user } = useUser();
  const navigate = useNavigate();
  const [companyMenuAnchorEl, setCompanyMenuAnchorEl] = useState<HTMLElement | null>(null);
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        backgroundColor: '#FFFFFF',
        borderBottom: `1px solid ${colorAgentBorder}`,
        height: 56,
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{ cursor: 'pointer', display: 'flex', alignItems: 'flex-end', gap: 0.5 }}
        onClick={() => navigate('/fa/main-menu')}
        title="メインメニューに戻る"
      >
        <img src="images/proplus_logo.png" alt="ProPlus+" style={{ height: 32 }} />
        <Typography
          sx={{
            color: colorPrimaryDeepBlue,
            fontSize: 11,
            fontWeight: 700,
            fontFamily: 'Inter, sans-serif',
            lineHeight: 1,
            pb: '2px',
          }}
        >
          AI Hub
        </Typography>
      </Box>

      {user && (
        <Stack
          direction="row"
          spacing={1}
          sx={{ alignItems: 'center' }}
          divider={<Divider orientation="vertical" sx={{ borderColor: '#B0B0B0', height: '60%' }} />}
        >
          <CompanyButton
            anchorEl={companyMenuAnchorEl}
            setAnchorEl={setCompanyMenuAnchorEl}
            user={user}
            isUnderSubsystem={true}
          />
          <UserButton user={user} anchorEl={userMenuAnchorEl} setAnchorEl={setUserMenuAnchorEl} />
        </Stack>
      )}

      {user && (
        <>
          <CompanyMenu user={user} anchorEl={companyMenuAnchorEl} setAnchorEl={setCompanyMenuAnchorEl} />
          <UserMenu user={user} anchorEl={userMenuAnchorEl} setAnchorEl={setUserMenuAnchorEl} />
        </>
      )}
    </Box>
  );
}
